<template>
    <td>
        <div class="input-group" v-if="!data.auto_app_goals">
            <span class="input-group-addon">$</span> <input type="text" class="form-control" style="width: 80px;" v-model="data.budget" disabled>
        </div>
        <div style="position:relative;" class="input-group" v-if="data.auto_app_goals">
            <span class="input-group-addon">$</span>
            <input type="text" class="form-control" style="width: 80px;" v-model="data.auto_app_goal_budget"
                   v-bind:disabled="isDisabled"
            >
            <div style="position:absolute; left:0; right:0; top:0; bottom:0; z-index: 100"
                 v-if="showSwitcher"
                 @click="data.singlecarrier.set_by_goals = false"></div>
        </div>
    </td>
</template>

<script>
export default {
    props: [
        'data'
    ],
    computed: {
        isDisabled() {
            if (!['driverboost', 'driverboost+jb', 'mc+driverboost', 'mc+driverboost+jb', 'jobadviser', 'uncapped_jb', 'direct'].includes(this.data.auto_lead_type))
                return false;

            return this.data.singlecarrier.set_by_goals;
        },
        showSwitcher() {
            return this.data.singlecarrier.set_by_goals && ['driverboost', 'driverboost+jb', 'mc+driverboost', 'mc+driverboost+jb', 'jobadviser', 'uncapped_jb', 'direct'].includes(this.data.auto_lead_type);
        }
    }
}
</script>